export const appHead = {"meta":[{"charset":"utf-8"},{"hid":"description","name":"description","content":"Travel Redefined. Everything you need for limitless travel, in one place."},{"hid":"keywords","name":"keywords","content":"travel, experiences, luxury, concierge, virtual, AR, VR, Meta, exclusive experiences, membership, moments"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow"},{"name":"author","content":"Paradise a La Carte"},{"name":"lang","content":"en-EN"},{"name":"date","content":"2025-11-13T08:59:12.449Z"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Paradise a La Carte"},{"property":"og:description","content":"Travel Redefined. Everything you need for limitless travel, in one place."},{"property":"og:url","content":"https://paradisealacarte.com"},{"property":"og:image","content":"https://media.licdn.com/dms/image/v2/D4D0BAQFoUcu0TfJUVg/company-logo_200_200/company-logo_200_200/0/1704966942092/paradise_a_la_carte_logo?e=1751500800&v=beta&t=vC5TQbooDQDSlg3tOiUT0lnwgiMU_fCCehG0S29SbQM"},{"property":"og:image:alt","content":"Paradise a La Carte"},{"property":"og:image:type","content":"image/jpeg"},{"property":"og:image:width","content":"200"},{"property":"og:image:height","content":"200"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Paradise a La Carte"},{"name":"twitter:description","content":"Travel Redefined. Everything you need for limitless travel, in one place."},{"name":"twitter:image","content":"https://pbs.twimg.com/profile_images/1355703194224111616/GfrXi_jI_400x400.jpg"},{"name":"twitter:site","content":"@CarteParadise"},{"name":"twitter:creator","content":"@CarteParadise"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/favicon-dark.svg"},{"rel":"preconnect","crossorigin":"","href":"https://5e8000da421d5b81372ee70086b80b02@o4506869242462208.ingest.us.sentry.io/4506869257404416"},{"rel":"preconnect","href":"https://maps.googleapis.com","crossorigin":""},{"rel":"preconnect","href":"https://apis.google.com","crossorigin":""},{"rel":"preconnect","href":"maps.googleapis.com","crossorigin":""},{"rel":"preconnect","href":"https://consent.cookiebot.com","crossorigin":""}],"style":[],"script":[],"noscript":[],"title":"Paradise a La Carte | Travel redefined","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"